import styled from 'styled-components';
import colors from '../../../../styles/colors';
import { ReactComponent as closeIcon } from '../../../../assets/icons/cross-cancel.svg';

const ReplyMessageContainer = styled.div`
  position: relative;
  padding: 5px 10px 10px 10px;
  width: 100%;
  background-color: ${colors.shades.primary1};
`;

const ReplyMessageContent = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 1.5rem;
`;

const ReplyMessage = styled.div`
  font-weight: 500;
  font-size: 14px;
  width: 95%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: absolute;
  display: inline-block;
`;

const StyledCloseIcon = styled(closeIcon)`
  width: 24px;
  height: 24px;
  position: absolute;
  right: 10px;
  top: 20px;
  > path {
    stroke: ${colors.base.secondary2};
  }
  cursor: pointer;
  margin: -12px 10px 0px auto;
`;

const ReplyDescription = styled.span`
  color: ${colors.base.alpha};
  font-size: 12px;
  font-weight: 500;
`;

const ReplyMessageInternalTextWarning = styled.div`
  color: ${colors.shades.danger3};
  background-color: ${colors.shades.primary7};
  line-height: 1.25em;
  border-radius: 2em;
  margin: 0.25em 0;
  font-size: 12px;
  font-weight: 500;
  padding: 0 10px;
`;

const AttachmentsLine = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 4px;
  padding: 5px 2px 2px 2px;
`;

export {
  ReplyMessageContainer,
  ReplyMessageContent,
  ReplyMessage,
  StyledCloseIcon,
  ReplyDescription,
  ReplyMessageInternalTextWarning,
  AttachmentsLine,
};
